import React from 'react';
import { motion } from 'framer-motion';
import { SingleBulletCarousel } from './SingleBulletCarousel';
import { HerDemoVideo } from './HerDemoVideo';

// "Cómo funciona": sección de confianza basada solo en hechos del producto.
// La identificación del problema ya aparece en otras secciones de la landing;
// se mantiene acá la demostración visual del producto, sin repetir la lista de dolores.

const STEPS = [{
  num: '01',
  title: 'Elegís tu acceso',
  text: 'Dejás tu email y completás el pago con Mercado Pago, en un solo pago o en cuotas.'
}, {
  num: '02',
  title: 'Recibís tu acceso por email',
  text: 'Con el Protocolo H.E.R. de 21 días y las herramientas que lo acompañan.'
}, {
  num: '03',
  title: 'Seguís el recorrido a tu ritmo',
  text: 'Tres fases de 7 días (días 1–7, 8–14 y 15–21), con comida, movimiento y descanso en cada una.'
}];
const RECORRIDO = ['Protocolo H.E.R. · 21 días', 'Tracker H.E.R.'];
const KIT = ['Recetario H.E.R. · 63 recetas', 'H.E.R. Movement', 'Noche en Calma', 'Guía de compras Argentina'];
const PUEDE_ACOMPANARTE = ['Un recorrido concreto para empezar sin tener que decidir por dónde arrancar.', 'Herramientas para observar cómo te sentís y registrar tu propio proceso.', 'Una combinación de alimentación, movimiento y descanso reunida en un mismo lugar.', 'Una estructura de 21 días que después podés adaptar a tu ritmo.'];
const fade = {
  initial: {
    opacity: 0,
    y: 16
  },
  whileInView: {
    opacity: 1,
    y: 0
  },
  viewport: {
    once: true
  },
  transition: {
    duration: 0.55
  }
};
export function HowItWorksSection() {
  return <section className="bg-gradient-section px-4 py-12 md:px-8 md:py-16" style={{
    paddingTop: '0px'
  }} data-id="element-333" data-mp="mkl5cpwp8051">
      <div className="mx-auto max-w-2xl space-y-8" data-id="element-334" data-mp="rclb4yzg9n9j">
        <motion.div {...fade} className="space-y-3 text-center" data-id="element-335" data-mp="rdecfkfn3kka">
        </motion.div>
        {/* La demostración queda en su lugar; se elimina únicamente el bloque redundante de dolores. */}
        <div className="divider-fine mx-auto w-16" data-id="element-336" data-mp="3uyk2huveprk4" />
        <HerDemoVideo data-id="element-337" data-mp="1254nev86xx4m" />
      </div>
    </section>;
}